export default __webpack_public_path__ + "static/media/thinking-person-outline.5bfcf391.svg";